import { useQuery } from "@tanstack/react-query"
import type { PropertyListResponse } from "@zplanem/responses"
import { apiFetch } from "../../lib/api-client"
import { queryKeys } from "../../lib/query-keys"

export function useProperties() {
	return useQuery({
		queryKey: queryKeys.properties(),
		queryFn: () => apiFetch<PropertyListResponse>("/api/common/properties"),
		select: (res) => res.properties,
	})
}
